import React from 'react';

import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import styled from 'styled-components';
import CriteriaTitle from '../CriteriaTitle';

const CustomExpansionPanel = styled(ExpansionPanel)`
  &&& {
    background: transparent;
    box-shadow: none;
    border-bottom: 1px solid #000;
    border-radius: 0;
    width: 100%;
    font-size: 1rem;
    padding-left: 0.25rem;

    & > div {
      padding-left: 0;
      padding-right: 0;
    }
  }
  :before {
    background-color: black !important;
  }
  :hover {
    cursor: pointer;
  }
`;

const Name = styled.h3`
  font-size: 16px;
`;

const NameWrapper = styled.div`
  // padding: 0 0 0 4px;
  font-size: 12px;
  font-weight: bold;
`;
const ExpansionPanelSummary1 = styled(ExpansionPanelSummary)`
  min-height: unset !important;
  & > div :first-child {
    margin: 8px 0 !important;
  }
  & > div :nth-child(2) {
    right: -4px !important;
  }
  // padding: 0 0 0 4px;
`;

const divStyle = {
  padding: '0px 0px 24px',
};
const divStyle1 = {
  padding: '0px 0px 10px',
};

class InternalSlips extends React.Component {
  render() {
    return (
      <CustomExpansionPanel
        expanded={this.props.isOpen}
        onChange={this.props.colapse}
      >
        <ExpansionPanelSummary1 expandIcon={<ExpandMore />}>
          <Name>Internal search results</Name>
        </ExpansionPanelSummary1>

        <ExpansionPanelDetails style={divStyle1}>
          <Grid container spacing={32}>
            {this.props.children}
          </Grid>
        </ExpansionPanelDetails>
      </CustomExpansionPanel>
    );
  }
}
export default InternalSlips;
